@if (viewModel.isLoading$ | push) {
  <app-loading [options]="viewModel.loadingOpts$ | push"> </app-loading>
}

<img (click)="viewModel?.navigateToRoot()" [src]="'assets/logo/dark/logo-stroke.svg'" alt="logo" class="nav-logo" />
<ul class="nav-list bs-menu-nav">
  @for (navItem of viewModel.navItems$ | push; track navItem.id) {
    <li>
      @if (navItem | isDefaultNavItem) {
        <app-nav-item [navItem]="navItem" [currentNavUrl]="viewModel.currentNavUrl$ | push"></app-nav-item>
      }
      @if (navItem | isProductsNavItem) {
        <app-products-nav-item
          [navItem]="navItem"
          [currentNavUrl]="viewModel.currentNavUrl$ | push"></app-products-nav-item>
      }
      @if (navItem | isSignOutNavItem) {
        <app-sign-out-nav-item [navItem]="navItem"></app-sign-out-nav-item>
      }
    </li>
  }
</ul>
<div class="sidebar-software-version">
  @if (viewModel.showSyncingIndicator$ | push) {
    <div class="refresh-container" [ngbTooltip]="'Refreshing data'">
      <svg class="spin-refresh" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 12 12" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.666667 0C1.03486 0 1.33333 0.298477 1.33333 0.666667V2.22866C2.43292 0.86964 4.11446 0 6 0C9.06022 0 11.5845 2.29042 11.9536 5.25084C11.9992 5.6162 11.7399 5.94932 11.3746 5.99488C11.0092 6.04044 10.6761 5.78119 10.6305 5.41583C10.3436 3.11449 8.37927 1.33333 6 1.33333C4.41488 1.33333 3.01332 2.12378 2.16962 3.33333H4C4.36819 3.33333 4.66667 3.63181 4.66667 4C4.66667 4.36819 4.36819 4.66667 4 4.66667H0.666667C0.298477 4.66667 0 4.36819 0 4V0.666667C0 0.298477 0.298477 0 0.666667 0ZM0.625436 6.00512C0.990796 5.95956 1.32391 6.21881 1.36947 6.58417C1.65644 8.88551 3.62073 10.6667 6 10.6667C7.58512 10.6667 8.98668 9.87622 9.83038 8.66667H8C7.63181 8.66667 7.33333 8.36819 7.33333 8C7.33333 7.63181 7.63181 7.33333 8 7.33333H11.3333C11.7015 7.33333 12 7.63181 12 8V11.3333C12 11.7015 11.7015 12 11.3333 12C10.9651 12 10.6667 11.7015 10.6667 11.3333V9.77134C9.56708 11.1304 7.88554 12 6 12C2.93978 12 0.415545 9.70958 0.0463862 6.74916C0.000826399 6.3838 0.260076 6.05068 0.625436 6.00512Z"
          fill="currentColor" />
      </svg>
    </div>
  } @else {
    <div
      class="web_socket_connection_status"
      [style.background-color]="viewModel.webSocketConnectionColor$ | push"></div>
  }
  <div>{{ viewModel.versionString$ | push }}</div>
</div>
